import {
    ModuleWithProviders,
    NgModule,
} from '@angular/core';
import {
    PageCategory,
    PageScope,
    providePageMeta,
} from '@app/router';

@NgModule()
export class RoleMetaModule {
    static forRoot(): ModuleWithProviders {
        return {
            ngModule: RoleMetaModule,
            providers: [
                providePageMeta({
                    title: 'Roles',
                    translationKey: 'page_roles',
                    routerLink: '/roles',
                    icon: 'users',
                    permission: 'Roles.View',
                    type: 'SubMenu',
                    parentRoute: '/users',
                    category: PageCategory.Tenant,
                    scope: PageScope.Global,
                }),
            ],
        };
    }
}
